module.exports = __webpack_public_path__ + "static/media/bg52.f4cba862.png";